import { createActions } from 'redux-actions';

import { Document, DocumentTypes } from '@models/Document';
import { GetAllDocumentParams, CreateDocumentParams } from '@apis/DocumentApi';
import { Pagination } from '@models/Pagination';

export type State = {
  [K in `${DocumentTypes}`]: {
    documents?: Document[] | null;
    pagination?: Pagination;
    isLoading?: boolean;
  }
};

export type DocumentsFetchPayload = GetAllDocumentParams;
export type DocumentCreatePayload = CreateDocumentParams;
export type StateUpdatePayload = Partial<State>;

export const {
  documentsFetch,
  documentCreate,
  stateUpdate,
  stateClear,
} = createActions(
  'DOCUMENTS_FETCH',
  'DOCUMENT_CREATE',
  'STATE_UPDATE',
  'STATE_CLEAR',
  {
    prefix: 'FEATURE_DOCUMENT',
  },
);
